import R from 'ramda'
export const caGraphSpecs = [
  {
    id: 'lost_opp_rev_vs_act_rev',
    yLabel: 'Lost Opportunity Revenue',
    xLabel: 'Actual Revenue',
    label: 'Lost Opportunity Revenue vs. Actual Revenue',
    xValKey: 'lostRevenue',
    yValKey: 'actualRevenue',
    group: 'CA',
  },
  {
    id: 'lost_opp_mwh_vs_act_mwh',
    yLabel: 'Lost Opportunity MWH',
    xLabel: 'Actual Generation MWH',
    label: 'Lost Opportunity MWH vs. Actual Generation MWH',
    xValKey: 'lostMwh',
    yValKey: 'actualGen',
    group: 'CA',
  },
  {
    id: 'lost_opp_margin_vs_act_margin',
    yLabel: 'Lost Opportunity Margin',
    xLabel: 'Actual Margin',
    label: 'Lost Opportunity Margin vs. Actual Margin',
    yValKey: 'lostMargin',
    xValKey: 'actualMargin',
    group: 'CA',
  },
]

export const createSpec = group => x => y => ({
  id: `${x.id}-vs-${y.id}`,
  yLabel: y.display,
  xLabel: x.display,
  label: `${y.display} vs. ${x.display}`,
  yValKey: y.id,
  xValKey: x.id,
  group,
})

const findGroup = group => R.find(({ id }) => id === group)
const findGof = findGroup('GOF')
const findGor = findGroup('GOR')
const findGoo = findGroup('GOO')
export const getGroups = kpiSpec => [findGof(kpiSpec), findGor(kpiSpec), findGoo(kpiSpec)]
export const serviceHour = {
  id: 'SERVHOUR',
  display: 'Service Hour',
}

export const createServiceHourSpecs = R.compose(
  R.chain(g => g.metrics.map(createSpec(g.id)(serviceHour))),
  R.filter(g => g),
  getGroups
)
